(function ($) {
    $.fn.hasScrollBar = function () {
        let extraHeight = this.get(0).scrollHeight - this.height();
        return extraHeight > 10;
    }
})(jQuery);

import { FloorplanFilters } from './filtering.js';
import { Drawers } from './drawers.js';

if ($('.mb-floorplans').length) {
    let floorplans = new FloorplanFilters;
}

if ($('.mb-floorplans .drawer').length) {
    Drawers.init();
}

if ($('.mb-floorplans .sidebar-filters').length) {
    // avar sticky = new Waypoint.Sticky({
    // 	element: $('.mb-floorplans .sidebar-filters .stuck-wrap'),
    // 	// stuckClass: 'stuck-filters',
    // 	wrapper: '<div class="stuck-filters" />',
    // 	offset: 40
    // });

    $('.mb-floorplans .sidebar-filters .stuck-wrap').outerHeight($(window).height() - parseInt($('.mb-floorplans .sidebar-filters .stuck-wrap').css('top'), 10));

    $(window).resize(function () {
        $('.mb-floorplans .sidebar-filters .stuck-wrap').outerHeight($(window).height() - parseInt($('.mb-floorplans .sidebar-filters .stuck-wrap').css('top'), 10));
    });
}

$('.hide-filters.type-drawer').click(function () {
    if (!$(this).parent().next().is(":visible")) {
        $(this).parent().next().slideDown();
        $(this).find('.dynamic').text('Hide');
    }
    else {
        $(this).parent().next().slideUp();
        $(this).find('.dynamic').text('Show');
    }
});